import type {LinkAction} from 'types';
import type {LinkedValueSearchFieldConfig} from 'feature/linkedValueSearch/types';
import {FieldExtensionEnum} from 'sceneExtensions/types';
import type {
  LinkedValueLink,
  VerifiedLinkedValueLink,
} from 'schemaDefinition/types';
import {useFieldExtensionContext} from 'sceneExtensions/hooks';
import type {LinkedValueSearchFieldExtensionContext} from '../types';

export const useLinkedValueSearchFieldExtension =
  (): LinkedValueSearchFieldExtensionContext => {
    return useFieldExtensionContext<
      FieldExtensionEnum.linkedValueSearch,
      LinkedValueLink,
      VerifiedLinkedValueLink,
      LinkAction,
      LinkedValueSearchFieldConfig
    >(FieldExtensionEnum.linkedValueSearch);
  };
